import InfoTooltip from 'src/components/Tooltip/InfoTooltip';

export { DescriptionTooltip } from './DescriptionTooltip';
export { TooltipWrapper } from './TooltipWrapper';
export { ExtensionTooltipTitle } from './ExtensionTooltipTitle';
export default InfoTooltip;
